import { Grid, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { useState } from 'react';
import PtoStatusHover from './pto-status-hover-';

export const EventContentComponent = ({ event }: any) => {
  const checkViewMode = event._context.viewApi.type;

  const IconPendingInDay = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <rect
          width="14"
          height="14"
          rx="7"
          fill="#F79009"
        />
        <path
          d="M11.0835 4.66927L8.75016 7.0026H10.5002C10.5002 8.93344 8.931 10.5026 7.00016 10.5026C6.411 10.5026 5.851 10.3568 5.36683 10.0943L4.51516 10.9459C5.23266 11.4009 6.08433 11.6693 7.00016 11.6693C9.5785 11.6693 11.6668 9.58094 11.6668 7.0026H13.4168L11.0835 4.66927ZM3.50016 7.0026C3.50016 5.07177 5.06933 3.5026 7.00016 3.5026C7.58933 3.5026 8.14933 3.64844 8.6335 3.91094L9.48516 3.05927C8.76766 2.60427 7.916 2.33594 7.00016 2.33594C4.42183 2.33594 2.3335 4.42427 2.3335 7.0026H0.583496L2.91683 9.33594L5.25016 7.0026H3.50016Z"
          fill="white"
        />
      </svg>
    );
  };

  const IconSuccessInDay = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M7.99967 1.33594C4.31967 1.33594 1.33301 4.3226 1.33301 8.0026C1.33301 11.6826 4.31967 14.6693 7.99967 14.6693C11.6797 14.6693 14.6663 11.6826 14.6663 8.0026C14.6663 4.3226 11.6797 1.33594 7.99967 1.33594ZM6.66634 11.3359L3.33301 8.0026L4.27301 7.0626L6.66634 9.44927L11.7263 4.38927L12.6663 5.33594L6.66634 11.3359Z"
          fill="#15B79E"
        />
      </svg>
    );
  };

  const IconRejectedInDay = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00016 1.33594C4.3135 1.33594 1.3335 4.31594 1.3335 8.0026C1.3335 11.6893 4.3135 14.6693 8.00016 14.6693C11.6868 14.6693 14.6668 11.6893 14.6668 8.0026C14.6668 4.31594 11.6868 1.33594 8.00016 1.33594ZM11.3335 10.3959L10.3935 11.3359L8.00016 8.9426L5.60683 11.3359L4.66683 10.3959L7.06016 8.0026L4.66683 5.60927L5.60683 4.66927L8.00016 7.0626L10.3935 4.66927L11.3335 5.60927L8.94016 8.0026L11.3335 10.3959Z"
          fill="#F04438"
        />
      </svg>
    );
  };

  const [isHovering, setIsHovering] = useState(false);
  const onMouseHoverEnter = () => {
    setIsHovering(true);
  };
  const onMouseHoverOut = () => {
    setIsHovering(false);
  };

  const monthViewStyle = {
    label: {
      fontSize: '12px',
      color: 'rgba(17, 25, 39, 0.38)',
      fontWeight: 500,
      marginTop: '-4px',
      marginLeft: '-5px',
    },
    container: {
      marginLeft: '10px',
      position: 'absolute',
      top: '14px',
    },
    weeklyBox: {
      marginLeft: '14px',

      backGroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  };

  const headTitle = {
    color: '#6C737F',
    fontSize: '12px',
    fontWeight: 500,
  };

  const subTitle = {
    color: '#111927',
    fontSize: '14px',
    fontWeight: 500,
    marginLeft: '8px',
  };

  const statusBox = {
    height: '24px',
    borderRadius: '12px',
    paddingBottom: '24px',
    marginTop: '4px',
  };

  const statusLabel = {
    fontWeight: 600,
    marginLeft: '8px',
    paddingTop: '2px',
    fontSize: '12px',
  };

  const weekEventStyle = {
    color: '#111927',
    // marginTop: '4px',
    fontWeight: 700,
    fontSize: '18px',
  };

  const totalPTos = event.extendedProps?.ptoRequest;
  let updatedTotalPTos: any, removedItem: any;

  if (totalPTos?.length > 1) {
    const indexToRemove = 1;
    updatedTotalPTos = totalPTos ? [...totalPTos] : null;
    removedItem = updatedTotalPTos?.splice(indexToRemove, 1)[0];
  }

  const checkIsNegative = (hours: any) => {
    if (hours > 0) return hours;
    return '0';
  };

  return (
    <Stack zIndex={1}>
      {checkViewMode === 'dayGridMonth' ? (
        <>
          {event.extendedProps.isBlocked ? (
            <Box sx={monthViewStyle.container}>
              <Typography
                title={'Blocked -'}
                sx={monthViewStyle.label}
              >
                Blocked -
              </Typography>
            </Box>
          ) : (
            <Grid
              sx={{
                width: '6rem',
              }}
            >
              <Box
                sx={{
                  background: 'rgba(56, 66, 80, 0.04)',
                  borderRadius: '8px',
                }}
                p={1}
              >
                <Typography style={headTitle}>
                  Hrs. <span style={subTitle}>{checkIsNegative(event.extendedProps.hours)}</span>
                </Typography>
                <Typography style={headTitle}>
                  Start: <span style={subTitle}>{event.extendedProps.start}</span>
                </Typography>
              </Box>

              {event.extendedProps.ptoRequest && (
                <Box sx={{ background: 'transparent !important' }}>
                  <Box>
                    {event.extendedProps.ptoRequest?.map((ptoRes: any, index: number) => {
                      if (index >= 1) return;
                      return (
                        <Box
                          key={ptoRes?.ptoHours}
                          sx={{
                            display: 'flex',
                            gap: 0.5,
                            alignItems: 'start',
                          }}
                          mt={2}
                        >
                          <Box>
                            {event.extendedProps?.ptoRequest?.length > 1 ? (
                              removedItem?.ptoStatus === 'APPROVED' ? (
                                <IconSuccessInDay />
                              ) : removedItem?.ptoStatus === 'PENDING' ? (
                                <IconPendingInDay />
                              ) : (
                                <IconRejectedInDay />
                              )
                            ) : ptoRes?.ptoStatus === 'APPROVED' ? (
                              <IconSuccessInDay />
                            ) : ptoRes?.ptoStatus === 'PENDING' ? (
                              <IconPendingInDay />
                            ) : (
                              <IconRejectedInDay />
                            )}
                          </Box>
                          <Box>
                            <Typography
                              sx={{
                                color: 'rgba(17, 25, 39, 0.38)',
                                fontSize: '12px',
                                fontWeight: 500,
                              }}
                            >
                              {event.extendedProps?.ptoRequest?.length > 1
                                ? removedItem?.ptoHours
                                : ptoRes?.ptoHours}{' '}
                              hrs. PTO
                            </Typography>
                            <Box
                              mt={0.4}
                              // {...hoverProps}
                              aria-describedby="overlay"
                              onMouseEnter={onMouseHoverEnter}
                              onMouseLeave={onMouseHoverOut}
                            >
                              {event.extendedProps.ptoRequest?.length > 1 && (
                                <Typography
                                  sx={{
                                    color: '#6C737F',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                  }}
                                  variant="body1"
                                >
                                  {updatedTotalPTos?.length} More
                                </Typography>
                              )}
                            </Box>
                            {isHovering ? (
                              <Box
                                id="overlay"
                                sx={{
                                  borderRadius: '4px',
                                  backgroundColor: 'rgba(108, 115, 127, 1)',
                                  boxShadow: ' 0px 1px 2px 0px rgba(0, 0, 0, 0.08)',
                                  position: 'relative',
                                  opacity: 1,
                                }}
                                p={1}
                                pr={3}
                              >
                                <PtoStatusHover ptoData={updatedTotalPTos} />
                              </Box>
                            ) : null}
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
            </Grid>
          )}
        </>
      ) : (
        <>
          {event.extendedProps.isBlocked ? (
            <Box sx={monthViewStyle.weeklyBox}>
              <Typography sx={monthViewStyle.label}>Blocked -</Typography>
            </Box>
          ) : (
            <Grid
              sx={{
                borderRadius: '8px',
                // margin: 'auto',
                padding: '8px 6px',
                display: 'flex',
                gap: 1,
                flexDirection: 'column',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <Typography sx={{ ...headTitle }}>Hours Available</Typography>
                <Typography sx={{ ...weekEventStyle }}>
                  {checkIsNegative(event.extendedProps.hours)}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <Typography sx={{ ...headTitle }}>Started</Typography>
                <Typography sx={{ ...weekEventStyle }}>{event.extendedProps.start}</Typography>
              </Box>
              {event.extendedProps.ptoRequest && (
                <Box sx={{ marginTop: 2 }}>
                  <Box sx={{ padding: '2px', display: 'flex', gap: 3, flexDirection: 'column' }}>
                    {event.extendedProps.ptoRequest?.map((ptoRes: any, index: number) => {
                      return (
                        <Box
                          key={ptoRes?.ptoHours}
                          sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
                        >
                          <Typography sx={{ color: '#6C737F', fontWeight: 500, fontSize: '14px' }}>
                            {ptoRes?.ptoHours} hrs. PTO
                          </Typography>

                          <Box
                            sx={{
                              ...statusBox,
                              background:
                                ptoRes.ptoStatus == 'APPROVED'
                                  ? 'rgba(21, 183, 158, 0.12)'
                                  : 'rgba(247, 144, 9, 0.12)',
                              width: ptoRes.ptoStatus == 'APPROVED' ? '85px' : '73px',
                            }}
                          >
                            <Typography
                              sx={{
                                ...statusLabel,
                                color: ptoRes.ptoStatus == 'APPROVED' ? '#107569' : '#B54708',
                              }}
                            >
                              {String(ptoRes.ptoStatus).toUpperCase()}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
            </Grid>
          )}
        </>
      )}
    </Stack>
  );
};
